import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type OpenInBrowserMutationVariables = Types.Exact<{
  input: Types.OpenInBrowserInput;
}>;


export type OpenInBrowserMutation = { __typename?: 'Mutation', openInBrowser?: boolean | null };


export const OpenInBrowser = /*#__PURE__*/ gql`
    mutation OpenInBrowser($input: OpenInBrowserInput!) {
  openInBrowser(input: $input)
}
    ` as unknown as DocumentNode<OpenInBrowserMutation, OpenInBrowserMutationVariables>;

          

          export const useOpenInBrowserMutation = (options?:MutationHookOptions<OpenInBrowserMutation, OpenInBrowserMutationVariables>) => useMutation(OpenInBrowser, options);
          

          export type OpenInBrowserMutationOptions = MutationHookOptions<OpenInBrowserMutation, OpenInBrowserMutationVariables>;

          

          export type OpenInBrowserMutationResult = ReturnType<typeof useOpenInBrowserMutation>[1];

          
